import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "./AuthForms.css"; // Import the CSS file

const ResetPassword = () => {
    const [email, setEmail] = useState("");
    const [otp, setOtp] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [message, setMessage] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError("");
        try {
            
            //const { data } = await axios.post("http://localhost:5000/reset-password", {
            const { data } = await axios.post("https://payweek.com/api/reset-password", {
                email,
                otp,
                newPassword,
            });
            alert("Password is changed");
            setMessage(data.message || "Password reset successful.");
            navigate("/login");
        } catch (err) {
            console.error(err);
            setError(err.response?.data?.error || "Error resetting password.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="auth-container">
            <div className="auth-card">
                <h2>Reset Password</h2>
                {message && <p className="auth-message auth-success">{message}</p>}
                {error && <p className="auth-message auth-error">{error}</p>}
                <form onSubmit={handleSubmit} className="auth-form">
                    <input
                        type="email"
                        placeholder="Enter your email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                        className="auth-input"
                    />
                    <input
                        type="text"
                        placeholder="Enter OTP"
                        value={otp}
                        onChange={(e) => setOtp(e.target.value)}
                        required
                        className="auth-input"
                    />
                    <input
                        type="password"
                        placeholder="New Password"
                        value={newPassword}
                        onChange={(e) => setNewPassword(e.target.value)}
                        required
                        className="auth-input"
                    />
                    <button type="submit" disabled={loading} className="auth-button">
                        {loading ? "Resetting..." : "Reset Password"}
                    </button>
                </form>
            </div>
        </div>
    );
};

export default ResetPassword;




// import React, { useState } from "react";
// import { useNavigate } from "react-router-dom";
// import axios from "axios";

// const ResetPassword = () => {
//     const [email, setEmail] = useState("");
//     const [otp, setOtp] = useState("");
//     const [newPassword, setNewPassword] = useState("");
//     const [message, setMessage] = useState("");
//     const [error, setError] = useState("");
//     const [loading, setLoading] = useState(false); // To handle loading state
//     const navigate = useNavigate();

//     const handleSubmit = async (e) => {
//         e.preventDefault();
//         setLoading(true); // Start loading
//         setError(""); // Clear any previous error
//         try {
//             // Make API call to reset password
//             const { data } = await axios.post("http://localhost:5000/reset-password", {
//                 email,
//                 otp,
//                 newPassword,
//             });
//             alert("Password is changed");
//             setMessage(data.message || "Password reset successful."); // Use message from the response
//             navigate("/authpage"); // Redirect to login page
//         } catch (err) {
//             console.error(err);
//             setError(err.response?.data?.error || "Error resetting password.");
//         } finally {
//             setLoading(false); // Stop loading
//         }
//     };

//     return (
//         <div className="reset-password">
//             <h2>Reset Password</h2>
//             {message && <p style={{ color: "green" }}>{message}</p>}
//             {error && <p style={{ color: "red" }}>{error}</p>}
//             <form onSubmit={handleSubmit}>
//                 <input
//                     type="email"
//                     placeholder="Enter your email"
//                     value={email}
//                     onChange={(e) => setEmail(e.target.value)}
//                     required
//                 />
//                 <input
//                     type="text"
//                     placeholder="Enter OTP"
//                     value={otp}
//                     onChange={(e) => setOtp(e.target.value)}
//                     required
//                 />
//                 <input
//                     type="password"
//                     placeholder="New Password"
//                     value={newPassword}
//                     onChange={(e) => setNewPassword(e.target.value)}
//                     required
//                 />
//                 <button type="submit" disabled={loading}>
//                     {loading ? "Resetting..." : "Reset Password"}
//                 </button>
//             </form>
//         </div>
//     );
// };

// export default ResetPassword;

